import React, { useState } from 'react';
import StorageComponent from '../components/StorageComponent';
import JobMonitorComponent from '../components/JobMonitorComponent';
import DecimationLayersComponent from '../components/DecimationLayersComponent';
import './Dashboard.css'; // Import the CSS file

function Dashboard() {
    const [activeTab, setActiveTab] = useState('jobs');

    return (
        <div className="dashboard-container">
            <h1 className="dashboard-title">System Dashboard</h1>
            
            <div className="tabs">
                <button 
                    className={`tab-button ${activeTab === 'jobs' ? 'active' : ''}`}
                    onClick={() => setActiveTab('jobs')}
                >
                    Jobs Monitor
                </button>
                <button 
                    className={`tab-button ${activeTab === 'storage' ? 'active' : ''}`}
                    onClick={() => setActiveTab('storage')}
                >
                    Storage Status
                </button>
                <button 
                    className={`tab-button ${activeTab === 'decimationLayers' ? 'active' : ''}`}
                    onClick={() => setActiveTab('decimationLayers')}
                >
                    Decimation Layers Status
                </button>
            </div>

            <div className="tab-content">
                {activeTab === 'jobs' && <JobMonitorComponent />}
                {activeTab === 'storage' && <StorageComponent />}
                {activeTab === 'decimationLayers' && <DecimationLayersComponent />}
            </div>
        </div>
    );
}

export default Dashboard;
